import React from "react";
import styles from "../Dashboard.module.css";

export default function Settings() {
  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <h1 className={styles.dashboardTitle}>SETTINGS</h1>
      <p>SuperAdmin settings page content goes here.</p>
    </div>
  );
}
